import { render, staticRenderFns } from "./subnav.vue?vue&type=template&id=0a4290eb"
import script from "./subnav.vue?vue&type=script&lang=ts"
export * from "./subnav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports